import LoadScript from "../utils/LoadScript";
import {gsap} from "../LibrariesImport";

export default class BlockBannerHome {
	static init() {

		let banner = document.querySelector('.banner-home');
		if (!banner) {
			return;
		}
		this.openButton = banner.querySelector('.popup-video-container');
		if (!this.openButton) {
			return;
		}

		this.iframeContainer = document.querySelector(".banner-youtube-player");
		this.iframe = document.querySelector('#youtube-player');
		this.close = this.iframeContainer.querySelector('.close');
		this.videoID = this.openButton.dataset.videoUrl;

		const that = this;

		this.openButton.addEventListener("click", () => {
			this.iframeContainer.classList.add("show");
			LoadScript.load('https://www.youtube.com/iframe_api', () => {
				if (window.YT && typeof YT.Player === 'function') {
					that.openVideo();
				} else {
					window.onYouTubeIframeAPIReady = this.openVideo.bind(this);
				}
			});
		});

		this.iframeContainer.addEventListener('click', function (e) {
			if (e.target !== this) {
				return;
			}
			that.iframeContainer.classList.remove('show');
			window.bannerHomeYoutubePlayer.pauseVideo();
		});

		this.close.addEventListener("click", () => {
			that.iframeContainer.classList.remove('show');
			window.bannerHomeYoutubePlayer.pauseVideo();
		});

		gsap.to(".banner-home .banner-movie", {
			y: "75%",
			opacity: 0,
			ease: "none",
			scrollTrigger: {
				trigger: ".banner-home",
				start: "top top",
				end: "bottom top",
				overwrite: true,
				scrub: true
			}
		});

	}

	static openVideo() {
		if (!this.iframe.classList.contains('player-load')) {
			this.iframe.classList.add('player-load');
			this.iframe.classList.add('playing');
			window.bannerHomeYoutubePlayer = new YT.Player("youtube-player", {
				height: '360',
				width: '640',
				videoId: this.videoID,
				playerVars: {
					'autoplay': 0,
					'showinfo': 0,
					'modestbranding': 1,
					'rel': 0,
					'enablejsapi': 1
				},
				events: {
					'onReady': (event) => {
						console.log("play");
						event.target.playVideo();
					}
				}
			});
		} else {
			window.bannerHomeYoutubePlayer.playVideo();
		}
	}
}
